import React from 'react'
import EmployeeProfileTabHeader from "./EmployeeProfileTabHeader";
import EmployeeProfileSectionCard from "./EmployeeProfileSectionCard";
import EmployeeProfileEmptyState from "./EmployeeProfileEmptyState";
import EmployeeProfileInfoBanner from "./EmployeeProfileInfoBanner";
import ScheduleIcon from "@mui/icons-material/Schedule";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { mergeAvailability2 } from '../../utilities/helpers';
import EmployeeProfileAvailabilityCard from './EmployeeProfileAvailabilityCard';

function EmployeeProfileAvailabilityTab(props) {

  const availabilityData2 = props.selectedTeamMemberAvailabilityData ? mergeAvailability2(
    props.selectedTeamMemberAvailabilityData?.current,
    props.selectedTeamMemberAvailabilityData?.approved,
    props.selectedTeamMemberAvailabilityData?.pending
  ) : []

  return (
    <div className="max-w-5xl mx-auto">
      {/* Header */}
      <EmployeeProfileTabHeader
        icon={AccessTimeIcon}
        title="Default Availability"
        subtitle="Weekly schedule and time preferences"
      />

      {/* Info Banner */}
      <EmployeeProfileInfoBanner>
        This is {props.selectedTeamMemberData?.first_name}'s default weekly
        availability. To view temporary availability changes or time off
        requests, check the availability section in the scheduling display.
      </EmployeeProfileInfoBanner>

      {/* Availability Container */}
      <EmployeeProfileSectionCard
        header={
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-gray-900">Availability</h3>

            {/* Legend */}
            <div className="flex items-center space-x-6 text-xs text-gray-500">
              <div className="flex items-center space-x-1.5">
                <ScheduleIcon style={{ fontSize: "16px" }} />
                <span>Availability</span>
              </div>
              <div className="flex items-center space-x-1.5">
                <StarBorderIcon style={{ fontSize: "16px" }} />
                <span>Preferences</span>
              </div>
              <div className="flex items-center space-x-1.5">
                <CalendarMonthIcon style={{ fontSize: "16px" }} />
                <span>Effective Date</span>
              </div>
            </div>
          </div>
        }
      >
        {availabilityData2?.length > 0 ? (
          <div className="space-y-3">
            {availabilityData2?.map((dow, index) => {
              return (
                <div key={index}>
                  <EmployeeProfileAvailabilityCard
                    dow={dow}
                    selectedTeamMemberData={props.selectedTeamMemberData}
                    create_availability_request={props.create_availability_request}
                    manager_rescind_availability_request={props.manager_rescind_availability_request}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <EmployeeProfileEmptyState
            icon={AccessTimeIcon}
            title="No availability set"
            description="This employee hasn't set their weekly availability yet."
          />
        )}
      </EmployeeProfileSectionCard>
    </div>
  )
}

export default EmployeeProfileAvailabilityTab
